export const shouldCloseChatPaneOnNavigation = (
  pathname: string,
): boolean => pathname === "/home";
